// export const CLIENT_ID = process.env.CLIENT_ID;
// export const CLIENT_SECRET = process.env.CLIENT_SECRET;
export const ACCESS_TOKEN_COOKIE = 'ct_access_token';
export const ANONYMOUS_ID_STORAGE_KEY = 'ct_anonymous_id';
